var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 0C6.04432 0 0 6.04432 0 13.5C0 20.9557 6.04432 27 13.5 27C20.9557 27 27 20.9557 27 13.5C27 6.04432 20.9557 0 13.5 0ZM14.7273 18.4091C14.7273 18.7346 14.598 19.0467 14.3678 19.2769C14.1377 19.5071 13.8255 19.6364 13.5 19.6364C13.1745 19.6364 12.8623 19.5071 12.6322 19.2769C12.402 19.0467 12.2727 18.7346 12.2727 18.4091V14.7273H8.59091C8.26542 14.7273 7.95325 14.598 7.7231 14.3678C7.49294 14.1377 7.36364 13.8255 7.36364 13.5C7.36364 13.1745 7.49294 12.8623 7.7231 12.6322C7.95325 12.402 8.26542 12.2727 8.59091 12.2727H12.2727V8.59091C12.2727 8.26542 12.402 7.95325 12.6322 7.7231C12.8623 7.49294 13.1745 7.36364 13.5 7.36364C13.8255 7.36364 14.1377 7.49294 14.3678 7.7231C14.598 7.95325 14.7273 8.26542 14.7273 8.59091V12.2727H18.4091C18.7346 12.2727 19.0467 12.402 19.2769 12.6322C19.5071 12.8623 19.6364 13.1745 19.6364 13.5C19.6364 13.8255 19.5071 14.1377 19.2769 14.3678C19.0467 14.598 18.7346 14.7273 18.4091 14.7273H14.7273V18.4091Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.279e74d9.svg";
export { ForwardRef as ReactComponent };